import React from 'react';
export function StatsBar() {
  const stats = [{
    value: '+800',
    label: 'parejas confían'
  }, {
    value: '6',
    label: 'Tomos listos'
  }, {
    value: '4.9/5',
    label: 'calificación ⭐'
  }, {
    value: '6',
    label: 'Bonos incluidos'
  }];
  return <div className="bg-navy-900/80 border-y border-navy-700/50 py-6" data-id="element-266">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-0 md:divide-x md:divide-navy-700/60" data-id="element-268">
          {stats.map((stat, index) => <div key={index} className="flex items-center gap-2.5 justify-center md:px-4 hero-animate-4" data-id="element-269">
              <span className="text-xl md:text-3xl font-bold font-poppins text-white" data-id="element-270">
                {stat.value}
              </span>
              <span className="text-[11px] md:text-sm text-slate-400 font-medium leading-tight max-w-[90px]" data-id="element-271">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}